/* eslint-disable react/prop-types */
import React from 'react';

export function Title({ children, className = '', style = {} }) {
  return (
    <h1 className={className} style={style}>
      {children}
    </h1>
  );
}

export function SubTitle({ children, className = '', style = {} }) {
  return (
    <h2 className={className} style={style}>
      {children}
    </h2>
  );
}

export function Description({ children, className = '', style = {} }) {
  return (
    <p className={`section-description ${className}`} style={style}>
      {children}
    </p>
  );
}

export function Highlight({ children }) {
  return <span className="highlight">{children}</span>;
}
